var $class="se2--utilities",$name="utilities",$path="app/components/utilities/checkHeaderExistence.js",$this={$class,$name,$path,};function checkHeaderExistence() {
  return !!document.querySelector('header');
}

export default checkHeaderExistence;
